// extracted by mini-css-extract-plugin
module.exports = {"tabTag":"deposit-tabs_tabTag__Hqz3j"};